export default __webpack_public_path__ + "9bb066e592f83ffa4e11f3d675e41352.png";